import { useTranslation } from 'libs/i18n'
import { useNavigate } from 'libs/router'
import { routes } from 'config/routes'
import type { Option } from 'shared/components/ContextMenu/types'
import type { OpeningHourItem } from 'features/openingHours/types/openingHours.types'

export const useContextMenuOptions = (): Option[] => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	return [
		{
			label: t('Edit'),
			action: (_id: undefined, openingHour: OpeningHourItem) =>
				navigate(routes.openingHourEdit(openingHour.date))
		}
	]
}
